import { Auth0Provider } from '@auth0/auth0-react';
import { QueryClientProvider } from '@tanstack/react-query';
import 'dayjs/locale/ar';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { initReactI18next } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import App from '../../App';
import { GlobalErrorEmptyState } from '../../common/components/global-error-empty-state';
import {
  ENV_CONFIG_AUTH0_AUDIENCE,
  ENV_CONFIG_AUTH0_CLIENT_ID,
  ENV_CONFIG_AUTH0_DOMAIN,
  ENV_CONFIG_PUBLIC_POSTHOG_HOST,
  ENV_CONFIG_PUBLIC_POSTHOG_KEY,
  ENV_CONFIG_PUBLIC_POSTHOG_PROXY_API_HOST,
} from '../../common/constants/env';
import { defaultQueryClient } from '../../common/defaultQueryClient';
import reportWebVitals from '../../reportWebVitals';
import './../../index.css';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: import.meta.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
  });

// DemoModeHelper.initDemoMode();

export const PmAppIndex = () => {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={defaultQueryClient}>
          <Auth0Provider
            domain={ENV_CONFIG_AUTH0_DOMAIN}
            clientId={ENV_CONFIG_AUTH0_CLIENT_ID}
            cacheLocation="localstorage"
            useRefreshTokens={true}
            useRefreshTokensFallback={true}
            authorizationParams={{
              redirect_uri: window.origin,
              audience: ENV_CONFIG_AUTH0_AUDIENCE,
              scope:
                'openid profile email read:current_user update:current_user_metadata',
            }}
            onRedirectCallback={(appState) => {
              if (appState?.setupTo) {
                window.location.href = appState.setupTo;
              }

              if (appState?.returnTo) {
                window.location.href = appState.returnTo;
              }
            }}
          >
            <RecoilRoot>
              <PostHogProvider
                apiKey={ENV_CONFIG_PUBLIC_POSTHOG_KEY}
                options={{
                  api_host: ENV_CONFIG_PUBLIC_POSTHOG_PROXY_API_HOST,
                  ui_host: ENV_CONFIG_PUBLIC_POSTHOG_HOST,
                }}
              >
                <ErrorBoundary FallbackComponent={GlobalErrorEmptyState}>
                  {/* <ErrorTestingComponent /> */}
                  <App />
                </ErrorBoundary>
              </PostHogProvider>
            </RecoilRoot>
          </Auth0Provider>
        </QueryClientProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export default PmAppIndex;
